import './App.css';
import { MsalAuthenticationTemplate} from "@azure/msal-react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from './authentication/authConfig';
import { ErrorComponent } from './components/ErrorComponent';
import { AuthenticationLoading } from './components/AuthenticationLoading';
import { Footer } from './components/Footer';
import css from "./styles/layout.module.scss";
import { Terms } from './containers/Terms';
import FeatureFlagWrapper from './components/FeatureFlagWrapper';
import LayoutRoute from './utils/LayoutRoute';

function App() {
  return (
    <div className="main-content">
      <Header />
      <div className={css.container}>
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect} 
            authenticationRequest={loginRequest} 
            errorComponent={ErrorComponent} 
            loadingComponent={AuthenticationLoading}
        >
          <Router basename={process.env.PUBLIC_URL}>
            <FeatureFlagWrapper>
              <Routes>
                <Route element={<LayoutRoute />}>
                  <Route exact path="/" element={<Terms />} />
                </Route>
              </Routes>
            </FeatureFlagWrapper>
          </Router>
        </MsalAuthenticationTemplate>
      </div>
      <Footer />
    </div>  
  );
}

export default App;
